import React from 'react';
import { feriaPromo } from '../helpers/utils';
import CrossingProduct from './CrossingProduct';

export default function Crossing() {
  const promo = feriaPromo();

  return (
    <div className="container-fluid bg-light-gray pt30 pb100 mt50">
      <div className="container">
        <div className="row">
          <div className="col-12 mb30">
            <h2 className="text-primary px-24">También te puede interesar</h2>
            <p className="px-16">
              Aprovecha y cotiza alguno de nuestros seguros
            </p>
          </div>
          <CrossingProduct
            name="Auto Full Cobertura"
            regularImage="//sfestaticos.blob.core.windows.net/feria/assets/img/genericos/auto.jpg"
            promoImage="//sfestaticos.blob.core.windows.net/feria/assets/img/auto.png"
            mark="feria-a-auto"
            url="//auto.segurosfalabella.com"
            promo={promo}
          />
          <CrossingProduct
            name="de Viajes"
            regularImage="//sfestaticos.blob.core.windows.net/feria/assets/img/genericos/viajes.jpg"
            promoImage="//sfestaticos.blob.core.windows.net/feria/assets/img/viajes.png"
            mark="feria-a-viajes"
            url="//viajes.segurosfalabella.com"
            promo={promo}
          />
          <CrossingProduct
            name="de Vida"
            regularImage="//sfestaticos.blob.core.windows.net/feria/assets/img/genericos/vida.jpg"
            promoImage="//sfestaticos.blob.core.windows.net/feria/assets/img/vida.png"
            mark="feria-a-vida"
            url="//vida.segurosfalabella.com"
            promo={promo}
          />
        </div>
      </div>
    </div>
  );
}
